// A ready-made demo deck so visitors can try the app without having a .pptx of
// their own on hand. The file is shipped as a static asset alongside the SPA
// (served by Firebase Hosting in production, and by the Cloud Run static mount
// in the bundled image), NOT by the API — so it loads from the SPA origin via
// Vite's BASE_URL rather than VITE_API_BASE_URL.

/** Filename of the bundled sample, as placed in `frontend/public/`. */
export const SAMPLE_FILENAME = "SampleDeck.pptx";

const SAMPLE_MIME = "application/vnd.openxmlformats-officedocument.presentationml.presentation";

/**
 * Fetch the bundled sample .pptx and wrap it in a {@link File} so it flows
 * through the exact same convert / layout-analysis path as a real upload —
 * no special-casing downstream.
 *
 * @throws Error if the static asset cannot be fetched.
 */
export async function loadSampleFile(): Promise<File> {
  const url = `${import.meta.env.BASE_URL}${SAMPLE_FILENAME}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`サンプルの読み込みに失敗しました (${res.status})`);
  }
  const blob = await res.blob();
  return new File([blob], SAMPLE_FILENAME, { type: SAMPLE_MIME });
}
